
export const STRAPI_KEY = "ec2623c0c9d13ac46327c22193f39a84dbe4c1d36070225aff78102786d540d90b4c517c9ab0d262c1a3a5b5cb10a4bda76627e45aa42645491b7015826510d14357d594faef232199fe70739968dda25a7bc81a9c2abe1f5550c953f22c870bd17e8940f24f9fd1f5595e9d820fb4bae978a68e8187681f535ec56ee9cb4881";
